<div
    class="card-content"
    [ngClass]="{ 'card-content--padding': displayPadding }"
>
    <ng-content></ng-content>
</div>
